import { createTheme } from "@mui/material";

// ── Custom palette tokens ───────────────────────────────────────────────────
// Extends MUI's background palette so theme.palette.background.subtle /
// .elevated and sx={{ bgcolor: "background.subtle" }} type-check. See
// README.md in this directory for when to reach for these instead of a new
// per-component theme.applyStyles("light"/"dark", {...}) pair.
declare module "@mui/material/styles" {
  interface TypeBackground {
    subtle: string;
    elevated: string;
  }
}

// create theme
export const MuiTheme = createTheme({
  colorSchemes: {
    light: {
      palette: {
        primary: {
          main: "#FFC051",
          light: "#FFC051",
          dark: "#68191B",
        },
        secondary: {
          main: "#68191B",
        },
        background: {
          // The two most-repeated theme.applyStyles pairs found across the
          // codebase — a light neutral fill and a fully elevated surface.
          subtle: "#fafafa",
          elevated: "#ffffff",
        },
      },
    },
    dark: {
      palette: {
        primary: {
          main: "#FFC051",
          light: "#FFC051",
        },
        secondary: {
          main: "#68191B",
        },
        background: {
          subtle: "#1a1a1a",
          elevated: "#101010",
        },
      },
    },
  },
  typography: {
    fontFamily: ["Cairo"].join(","),
    // Formalizes the weight scale that was already the de facto
    // convention (repeated inline sx={{ fontWeight: 600/700 }} on these
    // exact variants across the settlement pages) into named defaults.
    h6: { fontWeight: 700 },
    subtitle1: { fontWeight: 700 },
    subtitle2: { fontWeight: 700 },
    body2: { fontWeight: 400 },
  },
  shape: {
    // Matches the majority existing card borderRadius ("16px", hand-set
    // per-instance in dozens of files) — components can now drop that sx.
    borderRadius: 16,
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 600,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          // Already the de facto behavior everywhere buttons are used;
          // making it explicit here rather than relying on convention.
          textTransform: "none",
        },
      },
    },
  },
});
